export default function (
  blobParts: BlobPart[],
  filename: String | string,
  type: String | string = 'text/csv;charset=utf-8'
): void {
  // Create Blob for future download
  let blob = new Blob(blobParts, { type: (type as string) });
  if (navigator?.msSaveBlob) // IE 10+
    navigator?.msSaveBlob(blob, filename);
  else {
    // Make link for download
    let link = document.createElement('a') as HTMLAnchorElement;
    if (link.download !== undefined) {
      let url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', (filename as string));
      link.style.visibility = 'hidden';
      // Logic for download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  }
};
